export const isExpired = (data) => {
    const originalDate = new Date(data?.trialStartedAt)
    const targetDate = new Date(originalDate)
    targetDate.setDate(targetDate.getDate() + 5)

    const today = new Date()
    const timeDiff = targetDate.getTime() - today.getTime()
    const daysRemaining = Math.ceil(timeDiff / (1000 * 60 * 60 * 24))

    return data.pricingPlan !== 'Free' && (daysRemaining === -0 ? 0 : daysRemaining)
}
